export default "__VITE_ASSET__BOsps0nd__"